import { useContext, useEffect, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const ImagePrev = ({ setImgList, imgList, index }) => {


    const { BaseUrl } = useContext(MyContext);
    const [lightboximg, setLightBoxImg] = useState([]);

    useEffect(() => {
        const FilterImg = imgList.map((item) => ({ src: BaseUrl + item }));
        setLightBoxImg(FilterImg);
    }, [imgList]);

    return (<div>
        <Lightbox
            open={imgList}
            close={() => setImgList("")}
            slides={lightboximg}
            index={index}
            plugins={[Zoom]}
        />
    </div>)
}

export default ImagePrev;